import request from '@/utils/request'

export const getSEOList = (params: any) =>
  request({
    url: '/webpage/seo/list',
    method: 'get',
    params
  })

export const addEditSEO = (data: any) =>
  request({
    url: '/webpage/seo/save',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

export const deleteSEO = (data: any) =>
  request({
    url: '/webpage/seo/delete',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

export const setDefaultSEO = (data: any) =>
  request({
    url: '/webpage/seo/setDefault',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })
